import React from "react";
import { CharityIcon } from "@components/icons";

export const DonationBadge: React.FC = () => {
  return (
    <div className="flex size-9 items-center justify-center rounded-lg border border-grey-light bg-base-white">
      <CharityIcon className="size-4 text-blue-dark" />
    </div>
  );
};
